<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container
    class="px-6"
  >
    <v-progress-linear
      v-if="mainPageLoading"
      color="primary"
      indeterminate
    />
    <page-header>
      {{ $t('printer') }}
    </page-header>

    <div class="text-body-1 mb-6">
      {{ $t('printerTitleHin') }}
    </div>

    <div
      v-if="!mainPageLoading"
      style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));grid-gap: 12px"
    >
      <template v-for="(printer,index) in displayData.filter(item=> item.isPrinter)">
        <device-card
          :key="'normalPrinterWithID' + index"
          :device-index="index"
          :is-reception-printer="printer.isReceptionPrinter"
          :printer-object="printer"
          @delete="deleteDevice(printer)"
          @edit="editDevice(printer)"
          @test="testDevice(printer)"
        />
      </template>


      <device-card
        v-for="(printer,index) in displayData.filter(item=> !item.isPrinter)"
        :key="'stickerPrinterWithID' + index"
        :device-index="index"
        :printer-object="printer"
        @add="addDevice(printer)"
        @delete="deleteDevice(printer)"
      />


      <v-card
        class="pa-4 d-flex align-center justify-center"
        color="#eee"
        elevation="0"
        height="394"
        @click="createNewPrinter"
      >
        <div class="text-center">
          <v-icon size="48">
            mdi-plus
          </v-icon>
          <div>
            {{ $t('addNewPrinter') }}
          </div>
        </div>
      </v-card>
    </div>

    <v-dialog
      v-model="showNewDeviceDialog"
      max-width="600px"
      persistent
    >
      <add-new-device-dialog
        :printer-object="localPrinter"
        @cancle="handleCancle"
        @edit="handleEdit"
        @reload="loadData"
      />
    </v-dialog>

    <edit-dialog
      v-model="showEditDeviceDialog"
      :printer="localPrinter"
      :title=" $t('editPrinter') "
      @need-refresh="loadData"
    />

    <change-size-and-test-dialog
      v-model="showChangeAndTestDialog"
      :printer-object="localPrinter"
      @need-refresh="loadData"
    />
    <v-dialog
      v-model="deletePrinterDialog"
      max-width="600px"
    >
      <delete-printer-dialog
        :select-printer="selectPrinter"
        :wait-selected-printer="waitSelectedPrinter"
        @close="closeDeleteDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>


  import hillo from 'hillo'
  import Printer from '@/model/print/Printer'
  // import sumBy from 'lodash'
  import { IkDataTable } from 'metaflow-js'
  import AddNewDeviceDialog from '@/views/AadenPages/print/fragment/AddNewDeviceDialog'
  import DeviceCard from '@/views/AadenPages/print/fragment/DeviceCard'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import PageSubHeader from '@/composable/InK/typography/PageSubHeader'
  import PrinterGroup from '../../../model/print/PrinterGroup'
  import PrinterType from '../../../model/print/PrinterType'
  import EditDialog from './fragment/EditDialog'
  import ChangeSizeAndTestDialog from '@/views/AadenPages/print/fragment/ChangeSizeAndTestDialog'
  import DeletePrinterDialog from './fragment/DeletePrinterDialog'

  export default {
    components: {
      DeletePrinterDialog,
      ChangeSizeAndTestDialog,
      EditDialog,
      PageSubHeader,
      PageHeader,
      DeviceCard,
      AddNewDeviceDialog,
      IkDataTable,
    },
    data: function () {
      return ({
        waitSelectedPrinter: null,
        selectPrinter: null,
        deletePrinterDialog: null,

        mainPageLoading: false,
        displayData: [],
        showFastEditDialog: false,
        showNewDeviceDialog: false,
        showEditDeviceDialog: false,
        showChangeAndTestDialog: false,
        sectionHeaders: [],
        printTemplates: ['bill', 'Zwitchen', '贴纸', '厨房单', 'ZBon', 'Gutschein'],
        fixedHeader: [
          {
            text: 'name',
            value: 'name',
          },
          {
            text: 'sn',
            value: 'sn',
          },
        ],
        localPrinter: null,
      })
    },
    computed: {},
    watch: {
      displayData: {
        immediate: true,
        handler (val) {
          // this.reload()
        },
      },
    },
    async mounted () {
      await this.loadData()
    },
    methods: {
      async closeDeleteDialog () {
        this.deletePrinterDialog = false
        await this.loadData()
      },
      // async updateSection (item, sName, sId) {
      //   this.mainPageLoading = true
      //   item[sName] = !item[sName]
      //   if (item[sName]) {
      //     item.groupId.push(sId)
      //   } else {
      //     item.groupId.splice(item.groupId.indexOf(sId), 1)
      //   }
      //   item.groupIds = JSON.stringify(item.groupId)
      //   await hillo.post('Printer.php?op=edit', item)
      //   this.mainPageLoading = false
      // },
      clearAll () {
        this.mainPageLoading = true
        this.displayData.forEach(item => {
          item.groupId = []
          item.groupIds = JSON.stringify(item.groupId)
          hillo.post('Printer.php?op=edit', item)
        })
        this.mainPageLoading = false
      },
      /**
       * printerGroup id: 10 is not print
       * @returns {Promise<void>}
       */
      async loadData () {
        this.mainPageLoading = true
        const printerList = (await Printer.getList(true))
        const printerGroup = (await PrinterGroup.getList(true))
        const printerType = (await PrinterType.getList(true))

        console.log(printerType, 'printerType')
        console.log(printerGroup, 'printerGroup')
        console.log(printerList, 'printerList')

        const res = printerGroup.filter(i => i.id !== 10).map(function (item) {
          const printer = printerList.find(i => i.groupId?.includes(item.id))
          item.printerId = printer?.id
          item = printer ? Object.assign(printer, item) : item
          item.isPrinter = !!item.printerTypeId
          item.isStickerPrinter = item.printerTypeId === '9' || item.printerTypeId === '10'
          item.printerGroupId = item.id
          return item
        })

        this.displayData = res

        console.log(printerList, 'printerList')
        console.log(printerGroup, 'this.printerGroup')
        console.log(this.displayData, 'this.displayData')
        this.showNewDeviceDialog = false
        this.showChangeAndTestDialog = false
        this.mainPageLoading = false
      },

      createNewPrinter () {
        this.showNewDeviceDialog = true
        this.localPrinter = undefined
      },

      addDevice (printer) {
        this.showNewDeviceDialog = true
        this.localPrinter = printer
        console.log(this.localPrinter, 'add Device')
      },
      handleCancle () {
        this.showNewDeviceDialog = false
        this.localPrinter = null
      },

      handleEdit () {
        this.showEditDeviceDialog = true
      },

      editDevice (printer) {
        this.showEditDeviceDialog = true
        this.localPrinter = printer
      },

      testDevice (printer) {
        this.showChangeAndTestDialog = true
        this.localPrinter = printer
        console.log('click testDevice')
      },

      async deleteDevice (printer) {
        this.selectPrinter = printer
        this.deletePrinterDialog = true
        this.waitSelectedPrinter = this.displayData.filter(item => item.id !== printer.printerGroupId)
        if (printer.totalDishesCount === '0') {
          this.deletePrinterDialog = false
          await hillo.post('Printer.php?op=remove', { id: printer.printerId })
          await hillo.post('Printer.php?op=deletePrinterGroup', { id: printer.printerGroupId })
          await this.loadData()
        }
      },

    },
  }
</script>
